import { Button } from "@chakra-ui/react";

const BlackButton = ({ children, ...props }) => <Button bg='slate' color='#ffffff' {...props}>{children}</Button>

export default BlackButton;